<template>
  <v-container
    fluid
    fill-height
  >
    <v-layout
      align-center
      justify-center
    >
      <v-flex
        xs12
        sm8
        md4
      >

      Sorry, you don't have a 3Box account. Please <a href="https://www.3box.io/hub" target="_blank">Click here</a> to create one.

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { config } from '@/config'
export default {
  data: () => ({
  }),
  components: {

  },
  created () {

  }
}
</script>
